import { HIGHLIGHT_COLOR } from './editor-utils';

export const BLACK = '#000000';
export const DARK_BLUE = '#106292';
export const LIGHT_BLUE = '#80AEE1';
export const WHITE = '#ffffff';
export const RED = '#e3021e';

export const CALCULATOR_BACKGROUND = '#d6d3ce';
export const CALCULATOR_BUTTON_BACKGROUND = '#efefef';
export const CALCULATOR_BUTTON_COLOR_PRIMARY = '#0000ff';
export const CALCULATOR_BUTTON_COLOR_SECONDARY = '#ff0000';
export const DAT_HIGHLIGHT_CONTROLS = [HIGHLIGHT_COLOR.YELLOW];
